import PropTypes from 'prop-types';
import { FaRocket, FaWhatsapp, FaArrowRight } from 'react-icons/fa';
import { useState } from "react";
import LoadingButton from "../utils/Loading";
import { useNavigate } from 'react-router-dom';
import LoadingAction from '../utils/LoadingAction';

const ServiceCard = ({ icon: Icon, title, description, features, delay = 0 }) => {
  const [hireLoading, setHireLoading] = useState(false);
  const [processLoading, setProcessLoading] = useState(false);
  const navigate = useNavigate();
  const [whatLoading, setWhatLoading] = useState(false);

  return (
    <div
      className="col-lg-3 col-md-6 mb-4"
      data-aos="fade-up"
      data-aos-delay={delay}
    >
      <div className="card service-card-page">
        <div className="body">
          <div className="icon">
            <Icon />
          </div>
          <h2 className="title">{title}</h2>
          <p className="subtitle">{description}</p>
          <ul className="features">
            {features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
          <div className="hero-buttons d-flex flex-wrap justify-content-center mb-3">
            <LoadingButton 
              isLoading={hireLoading}
              onClick={() => 
                LoadingAction(
                  setHireLoading,
                  () => navigate("/#contact"),
                )
              } 
              className="btn btn-primary rounded-pill shadow hire-btn">
              <FaRocket size={18} className="mr-2" />
              Hire Me
            </LoadingButton>
            <LoadingButton
              isLoading={whatLoading}
              onClick={() =>
                LoadingAction(
                  setWhatLoading,
                  () => {
                    const newWindow = window.open(
                      "https://wa.me/918982896759?text=Hi%20Tehzeeb,%20I%20visited%20your%20portfolio%20and%20would%20like%20to%20discuss%20a%20project.", 
                      "_blank", 
                      "noopener,noreferrer"
                    );

                    if (newWindow) {
                      newWindow.opener = null;
                    }
                  }
                )
              }
              className="btn btn-outline-primary rounded-pill shadow service-btn"
            >
              <FaWhatsapp size={18} className="mr-2" />
              WhatsApp Me
            </LoadingButton>
          </div>
          <LoadingButton 
            isLoading={processLoading} 
            onClick={() =>
              LoadingAction(
                setProcessLoading,
                () => navigate("/services-page#process"),
              )
            } 
            className="btn btn-outline-primary rounded-pill shadow service-btn w-100">
            View Process
            <FaArrowRight size={15} className='ml-2' />
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};

ServiceCard.propTypes = {
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  delay: PropTypes.number,
};

export default ServiceCard;
